import * as Api from '@ViewModels';
import React from 'react';
import { toast } from 'sonner';
import { useUserSession } from './appStateHooks';

const CeteraAIDisclaimerDescription = () => (
	<div>
		This content was generated using artificial intelligence and is being provided for illustrative purposes only.
		Content should be reviewed for potential inaccuracies and edited accordingly.
		<br />
		<br />
		Advertising must be submitted to Advertising Review in Pinpoint Global (PPG) for approval prior to posting.
		Financial professionals are responsible for reviewing the AI-generated content carefully, adding required
		disclosures, and ensuring compliance before submission.
		<br />
		<br />
		<strong>Risks:</strong> While Levitate continually measures and optimizes the accuracy of our artificial
		intelligence outputs, it is important to note that AI is considered experimental. The information provided by
		Levitate&apos;s Ask Lev in this email should be used for informational purposes only and should not be solely relied
		upon for critical decision-making.
	</div>
);

// Cetera requires this AI disclaimer on AI-generated content for AI Assistant approval.
const showCeteraAIDisclaimer = () => {
	toast.warning(<strong>AI Content Disclaimer</strong>, {
		description: <CeteraAIDisclaimerDescription />,
		duration: 60000,
		closeButton: true,
		style: {
			minWidth: '700px', // Width chosen to accommodate disclaimer text without excessive wrapping
			left: '50%',
			transform: 'translateX(-50%)',
		},
	});
};

/**
 * Hook that returns a function to show the Cetera AI disclaimer toast.
 * The returned function checks the account's broker dealer and only shows the
 * disclaimer for Cetera accounts.
 */
export function useCeteraAIDisclaimer() {
	const userSession = useUserSession();

	const showDisclaimer = React.useCallback(() => {
		if (userSession.account?.additionalInfo?.brokerDealer === Api.FinancialBrokerDealer.Cetera) {
			showCeteraAIDisclaimer();
		}
	}, [userSession.account?.additionalInfo?.brokerDealer]);

	return showDisclaimer;
}
